// extracted by mini-css-extract-plugin
export default {"cls1":"PaperNewsStory-cls1_XH1","cls2":"PaperNewsStory-cls2__jF PaperNewsStory-cls1_XH1"};